
export const Provinces = [
    "hà nội"
    ,"hòa bình"
    ,"sơn la"
    ,"điện biên"
    ,"lai châu"
    ,"lào cai"
    ,"yên bái"
    ,"phú thọ"
    ,"hà giang"
    ,"tuyên quang"
    ,"cao bằng"
    ,"bắc kạn"
    ,"thái nguyên"
    ,"lạng sơn"
    ,"bắc giang"
    ,"quảng ninh"
    ,"bắc ninh"
    ,"hà nam"
    ,"hải dương"
    ,"hải phòng"
    ,"hưng yên"
    ,"nam định"
    ,"thái bình"
    ,"vĩnh phúc"
    ,"ninh bình"
    ,"thanh hóa"
    ,"nghệ an"
    ,"hà tĩnh"
    ,"quảng bình"
    ,"quảng trị"
    ,"Huế"
    ,"đà nẵng"
    ,"quảng nam"
    ,"quảng ngãi"
    ,"bình định"
    ,"phú yên"
    ,"khánh hòa"
    ,"ninh thuận"
    ,"bình thuận"
    ,"kon tum"
    ,"gia lai"
    ,"đắk lắk"
    ,"đắk nông"
    ,"lâm đồng"
    ,"hồ chí minh"
    ,"sài gòn"
    ,"bà rịa vũng tàu"
    ,"bình dương"
    ,"bình phước"
    ,"đồng nai"
    ,"tây ninh"
    ,"bạc liêu"
    ,"bến tre"
    ,"cà mau"
    ,"cần thơ"
    ,"hậu giang"
    ,"kiên giang"
    ,"long an"
    ,"sóc trăng"
    ,"tiền giang"
    ,"trà vinh"
    ,"vĩnh long"
    ,"an giang"
    ,"đồng tháp"
]

export const AREA_OPTIONS = [
    {value: "miền bắc", label : "Miền Bắc"},
    {value: "miền trung", label : "Miền Trung"},
    {value: "miền nam", label : "Miền Nam"}
]

const capitalizeNameLocal = (str) => {
    if (!str) return "";
    return str.replace(/(?:^|\s|["'([{])+\S/g, match => match.toUpperCase());
};

export const PROVINCE_OPTIONS = Provinces.map(item => {
    return {value: item.toLowerCase(), label : capitalizeNameLocal(item)}
})
